export default {
  data() {
    return {
      isHorizontalScreen: false,
    };
  },
  mounted() {
    this._initLandscape();
  },
  computed: {
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    // 首页模板 标题样式：居中 | 居左
    titleAlignmentClass() {
      let className = ''
      let titleAlignment = this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignment
      if (this.IsMobile) {
        titleAlignment = this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignmentH5;
      }
      if(titleAlignment === 'TITLE_ALIGNMENT_LEFT') {
        className = 'title-style1'
      }
      if(titleAlignment === 'TITLE_ALIGNMENT_CENTER') {
        className = 'title-style2'
      }
      return className
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignment
    },
    // 判断是否在TG APP 下全屏模式下运行 用于 移动端全屏 适配安全区域
    isInTelegramWebApp() {
      try {
        // 检查平台信息
        const platform = window.Telegram.WebApp.platform;
        // 并且是 安卓 ios tg设备
        return this.isTgFullscreen && ["android", "ios"].includes(platform);
      } catch (e) {
        return false;
      }
    },
    // 判断是否在TG 全屏 所有平台应用下全屏模式下运行 用于window/macos 端也需要适配header
    isTgFullscreen() {
      try {
        return this.isTgApp && this.isTgVersionGt8;
      } catch (e) {
        return false;
      }
    },
    isTgVersionGt8() {
      try {
        // 检查是否存在 WebApp 对象
        if (!window.Telegram?.WebApp) {
          return false;
        }
        // 大于8.0 才支持全屏
        const version = window.Telegram.WebApp.version;
        return Boolean(this.isTgApp && version >= "8.0");
      } catch (e) {
        return false;
      }
    },
    // TG APP 进入
    isTgApp() {
      //   return true;
      try {
        // 检查是否存在 WebApp 对象
        if (!window.Telegram?.WebApp) {
          return false;
        }
        // 检查平台信息
        const platform = window.Telegram.WebApp.platform;
        // 检查初始化数据
        const initDataUnsafe = window.Telegram.WebApp.initDataUnsafe;
        return Boolean(platform && initDataUnsafe);
      } catch (e) {
        return false;
      }
    },
    // 不区分真实账户模式
    isIgnoreRealAccount() {
      const withdrawMode = this.$store?.getters?.getPacketConfig?.appConfig?.withdrawMode;
      return withdrawMode === "WITHDRAW_MODE_IGNORE" || withdrawMode === 5;
    }
  },
  methods: {
    isTgAppCoinCode(item) {
      return (this.isTgApp && ["TON", "USDT", "TON experience", "USDT experience"].includes(item.coinCode)) || !this.isTgApp;
    },

    // 判断是否是二级路由
    isSubRoute() {
      // 获取当前路由路径
      const currentPath = this.$route.path;
      // 统计路径中 '/' 的数量，超过1个则为二级及以上路由
      const slashCount = (currentPath.match(/\//g) || []).length;
      return slashCount > 1;
    },
    // 监听是否是横屏
    _initLandscape() {
      this.landscape = window.matchMedia("(orientation: landscape)");
      this.landscape.addEventListener("change", this._landlister);
    },
    _landlister(e) {
      this.isHorizontalScreen = !!e.matches;
    },
  },
  destroyed() {
    this.landscape.removeEventListener("change", this._landlister);
  },
};
